module.exports = __webpack_public_path__ + "media/info/info-notification--icon-717dd1b1.svg";